/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EncashmentOperationType = {
    PURCHASE: 'PURCHASE',
    COLLECTION: 'COLLECTION',
    WITHDRAWAL: 'WITHDRAWAL',
    ADJUSTMENT: 'ADJUSTMENT'
} as const;
export type EncashmentOperationType = typeof EncashmentOperationType[keyof typeof EncashmentOperationType];

